// pattern matches 12345-1234 and 12345
import { ValidatorFn, AbstractControl } from '@angular/forms';

export function zipCodeValidator(pattern: RegExp = /^[0-9]{5}(?:-[0-9]{4})?$/): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const test = pattern.test(control.value);
    return test ? null : {zipCode: {value: control.value}};
  };
}
